import Phaser from "phaser";
import { PurpleBtn } from "@phaser/ui/btns/PurpleBtn";
import type { ShopViewItem } from "@phaser/core/shop/shopTypes";
import { t } from "@/i18n/i18n";

interface ShopItemSlotOptions {
  width: number;
  height: number;
  item: ShopViewItem;
}

export class ShopItemSlot extends Phaser.GameObjects.Container {
  constructor(
    scene: Phaser.Scene,
    x: number,
    y: number,
    options: ShopItemSlotOptions,
  ) {
    super(scene, x, y);
    scene.add.existing(this);

    const { width, height, item } = options;

    //  아이템 슬롯 배경
    const bg = scene.add.image(width / 2, height / 2, "shop-item-slot-bg");

    // 빵빠레 효과 (장착된 경우만)
    let sunburst: Phaser.GameObjects.Image | undefined;

    const thumbX = width * 0.195;
    const thumbY = height / 2;

    if (item.equipped) {
      sunburst = scene.add.image(thumbX, thumbY, "sunburst-fx");

      scene.tweens.add({
        targets: sunburst,
        angle: 360,
        duration: 10000,
        repeat: -1,
        ease: "Linear",
      });
    }

    //  아이템 이미지

    // 왼쪽 화살표: frame 0
    const leftArrow = scene.add
      .sprite(thumbX - 40, thumbY - 30, item.textureKey, 0)
      .setScale(0.4)
      .setOrigin(0.5);

    // 오른쪽 화살표: frame 1
    const rightArrow = scene.add
      .sprite(thumbX + 40, thumbY + 30, item.textureKey, 1)
      .setScale(0.4)
      .setOrigin(0.5);

    // 상품 이름
    const name = this.scene.add
      .text(width * 0.69, height * 0.32, t(`arrow.${item.id}.name`), {
        fontFamily: "Black Han Sans",
        fontSize: "40px",
        color: "#FFFFFF",
        align: "center",
        wordWrap: {
          width: 350,
        },
      })
      .setOrigin(0.5);

    const isPriceState = !item.equipped && !item.owned;

    const buttonLabel = item.equipped
      ? t("common.equipped")
      : item.owned
      ? t("common.select")
      : "";

    // 구매 버튼
    const btn = new PurpleBtn(
      this.scene,
      width * 0.69,
      height * 0.71,
      buttonLabel,
      () => {
        if (item.equipped) return;

        if (item.owned) {
          this.scene.events.emit("equip-item", {
            itemId: item.id,
          });
          return;
        }

        this.scene.events.emit("purchase-confirm", {
          itemId: item.id,
        });
      },
      {
        disabled: item.equipped,
        selected: item.equipped,
        coinAmount: isPriceState ? item.price : undefined,
      },
    );

    this.add([bg, name, btn]);

    if (sunburst) {
      this.add(sunburst);
    }

    this.add([leftArrow, rightArrow]);
  }
}
